import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, shareReplay } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MapsService {
  public apiLoaded = false;
  private readonly apiKey = 'AIzaSyCaACj70vadtqpe-FkDRQg9LObVb_vbN7w';
  private readonly libraries = 'places,drawing,geometry';

  constructor(private httpClient: HttpClient) {}

  loadedGoogleMapsApi$ = this.httpClient
    .jsonp(
      `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=${this.libraries}`,
      'callback'
    )
    .pipe(
      map(() => {
        this.apiLoaded = true;
        return true;
      }),
      catchError(() => of(false)),
      shareReplay(1)
    );

  isAPILoaded(): boolean {
    return this.apiLoaded;
  }
}
